import type { NavigationGuard, RouteRecordRaw } from 'vue-router'

import { useFeatureFlags } from '@/composables/useFeatureFlags'
import useHasPermissionUser from '@/composables/useHasPermissionUser'

// Interruptor maestro de autobuses (ver flightsGuard en plane.routes.ts). Bloquea
// el acceso por URL aunque no aparezca en el menú.
const busesGuard: NavigationGuard = (_to, _from, next) => {
	const { busesEnabled } = useFeatureFlags()
	if (!busesEnabled) {
		return next({ path: '/error/not-found' })
	}
	return next()
}

export default {
	path: '/services/bus',
	name: 'bus.form',
	component: () => import('@/modules/buses/pages/BusForm.vue'),
	meta: {
		serviceName: 'Bus',
	},
	// Mismo gate que car.form y hotel.availability. La ruta no tenía guard, así que
	// al habilitarla cualquier usuario autenticado podría abrir el formulario sin
	// permiso de crear solicitudes de autobús.
	beforeEnter: [
		busesGuard,
		(to, from, next) => {
			const { hasPermissionUser } = useHasPermissionUser()

			if (hasPermissionUser('create-bus', 'App\\Models\\Request')) {
				return next()
			} else {
				return next({
					path: '/error/not-found',
				})
			}
		},
	],
} as RouteRecordRaw
